module.exports = __webpack_public_path__ + "static/media/logoicon.a5a51e64.png";